import React, { useState, useEffect } from 'react';
import { Grid, TableBody } from '@mui/material';
import {
  StyledTableCell,
  StyledWithdrawTableRow,
} from '../../Components/MaterialTableStyle/StyleTableCell';
import { FormatDate } from '../../Components/DateFormats/DateFromat';
import { BridgeTable } from './BridgeTable';
import BigNumber from 'bignumber.js';
import { REACT_APP_USDT_TOKEN_DECIMALS } from '../../Config/Config';

const TransactionTable = ({ Transactions }) => {
  const [InitialData, setInitialData] = useState([]);
  const [Loader, setLoader] = useState(false);

  useEffect(() => {
    setInitialData(Transactions);
    setLoader(true);
  }, [Transactions]);

  useEffect(() => {
    if (Loader) {
      setTimeout(() => {
        setLoader(false);
      }, 1000);
    }
  }, [Loader]);

  const formatter = new Intl.NumberFormat('en-US', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 5,
  });

  const transactionsColumns = [
    {
      id: 1,
      columnName: 'Ethereum (L1)',
    },
    {
      id: 2,
      columnName: 'OpenZK (L2)',
    },
    {
      id: 3,
      columnName: 'Action',
    },
    {
      id: 4,
      columnName: 'Direction',
    },
    {
      id: 5,
      columnName: 'Initiated',
    },
  ];

  return (
    <Grid
      container
      lg={12}
      display={'flex'}
      flexDirection={'row'}
      alignItems={'flex-start'}
      justifyContent={'flex-start'}
    >
      <Grid
        container
        lg={12}
        display={'flex'}
        flexDirection={'column'}
        alignItems={'center'}
        justifyContent={'center'}
        className="BridgeGlassCard"
      >
        <BridgeTable
          columns={transactionsColumns}
          isEmpty={InitialData?.length === 0}
          isLoading={Loader}
        >
          {InitialData?.length > 0 && (
            <TableBody
              sx={{
                backgroundColor: '#28282B',
                padding: '16px',
                borderRadius: '12px',
              }}
            >
              {InitialData.map((row, i) => (
                <StyledWithdrawTableRow
                  key={i}
                  style={
                    i % 2 == 0
                      ? { background: '#3B3B3D' }
                      : { background: 'transparent' }
                  }
                >
                  <StyledTableCell
                    sx={{
                      fontFamily: 'Poppins',
                      fontSize: { xs: '12px', md: '16px !important' },
                      fontWeight: '500',
                      lineHeight: '24px',
                    }}
                  >
                    <Grid
                      display={'flex'}
                      flexDirection={'row'}
                      alignItems={'center'}
                    >
                      <span>
                        {' '}
                        {formatter.format(
                          BigNumber(row?.l1Amount.toString())
                            .div(Math.pow(10, 18))
                            .toString(),
                        )}{' '}
                        {row?.l1Token} {row?.l2Token === 'OZUSD' && 'ozUSD'}{' '}
                        {row?.l2Token === 'OZETH' && 'ETH'}
                      </span>
                    </Grid>
                  </StyledTableCell>
                  <StyledTableCell
                    sx={{
                      fontFamily: 'Poppins',
                      fontSize: { xs: '12px', md: '16px !important' },
                      fontWeight: '500',
                      lineHeight: '24px',
                    }}
                  >
                    {row?.l1Token == 'ETH' && (
                      <Grid
                        display={'flex'}
                        flexDirection={'row'}
                        alignItems={'center'}
                      >
                        <span>
                          {' '}
                          {formatter.format(
                            BigNumber(row?.l2Amount.toString())
                              .div(Math.pow(10, 18))
                              .toString(),
                          )}{' '}
                          ozETH
                        </span>
                      </Grid>
                    )}{' '}
                    {row?.l1Token == 'DAI' && (
                      <Grid
                        display={'flex'}
                        flexDirection={'row'}
                        alignItems={'center'}
                      >
                        <span>
                          {' '}
                          {formatter.format(
                            BigNumber(row?.l2Amount.toString())
                              .div(Math.pow(10, 18))
                              .toString(),
                          )}{' '}
                          ozUSD
                        </span>
                      </Grid>
                    )}{' '}
                    {row?.l1Token == 'USDC' && (
                      <Grid
                        display={'flex'}
                        flexDirection={'row'}
                        alignItems={'center'}
                      >
                        <span>
                          {' '}
                          {formatter.format(
                            BigNumber(row?.l2Amount.toString())
                              .div(Math.pow(10, 18))
                              .toString(),
                          )}{' '}
                          ozUSD
                        </span>
                      </Grid>
                    )}{' '}
                    {row?.l1Token == 'USDT' && (
                      <Grid
                        display={'flex'}
                        flexDirection={'row'}
                        alignItems={'center'}
                      >
                        <span>
                          {' '}
                          {formatter.format(
                            BigNumber(row?.l2Amount.toString())
                              .div(Math.pow(10, 18))
                              .toString(),
                          )}{' '}
                          ozUSD
                        </span>
                      </Grid>
                    )}{' '}
                    {row?.l2Token == 'OZUSD' && (
                      <Grid
                        display={'flex'}
                        flexDirection={'row'}
                        alignItems={'center'}
                      >
                        <span>
                          {' '}
                          {formatter.format(
                            BigNumber(row?.l2Amount.toString())
                              .div(Math.pow(10, 18))
                              .toString(),
                          )}{' '}
                          ozUSD
                        </span>
                      </Grid>
                    )}{' '}
                    {row?.l2Token == 'OZETH' && (
                      <Grid
                        display={'flex'}
                        flexDirection={'row'}
                        alignItems={'center'}
                      >
                        <span>
                          {' '}
                          {formatter.format(
                            BigNumber(row?.l2Amount.toString())
                              .div(Math.pow(10, 18))
                              .toString(),
                          )}{' '}
                          ozETH
                        </span>
                      </Grid>
                    )}{' '}
                  </StyledTableCell>
                  <StyledTableCell
                    sx={{
                      fontFamily: 'Poppins',
                      fontSize: { xs: '12px', md: '16px !important' },
                      fontWeight: '500',
                      lineHeight: '24px',
                    }}
                  >
                    <span>
                      {row.direction === 'L1 > L2'
                        ? 'Stake + Bridge'
                        : 'Bridge'}
                    </span>
                  </StyledTableCell>
                  <StyledTableCell
                    sx={{
                      fontFamily: 'Poppins',
                      fontSize: { xs: '12px', md: '16px !important' },
                      fontWeight: '500',
                      lineHeight: '24px',
                    }}
                  >
                    <span>{row.direction}</span>
                  </StyledTableCell>
                  <StyledTableCell
                    sx={{
                      fontFamily: 'Poppins',
                      fontSize: { xs: '12px', md: '16px !important' },
                      fontWeight: '500',
                      lineHeight: '24px',
                    }}
                  >
                    <span>
                      {FormatDate(new Date(row?.timestamp).getTime())}
                    </span>
                  </StyledTableCell>
                </StyledWithdrawTableRow>
              ))}
            </TableBody>
          )}
        </BridgeTable>
      </Grid>
    </Grid>
  );
};

export default TransactionTable;
